<template>
  <div class="filter-content">
    <div style="position: relative">
      <!-- <div style="position:absolute; "> -->
      <div class="pointer">
        <span v-preventReClick @click="showSelectDiv" class="select-text">展示范围<i :class="{
          'el-icon-caret-top': !isShowSelectDiv,
          'el-icon-caret-bottom': isShowSelectDiv,
        }"></i></span>
      </div>

      <i v-show="isShowSelectDiv" class="select-triangle-left"></i>
      <i v-show="isShowSelectDiv" class="select-triangle-right"></i>
      <div v-show="isShowSelectDiv" class="select-content" ref="fileterDiv">
        <div>
          <el-form ref="query" :model="query" label-width="130px">
            <el-row>
              <el-col :span="8" v-for="(item, index) in options" v-show="item.showMethod
                  ? query[item.showMethod.code] == item.showMethod.value
                  : true
                " :key="index">
                <el-form-item :label="item.name + ':'" v-if="!item.hidden">
                  <el-date-picker v-if="item.type == 'datetimerange'" v-model="query[item.code]" size="mini"
                  :default-time="['00:00:00', '23:59:59']" type="datetimerange"
                    style="width: 100%" :format="item.format ? item.format : 'yyyy-MM-dd'"
                    :value-format="item.format ? item.format : 'yyyy-MM-dd'" @input="(val) => timerangeChange(val, item)"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>

                  <el-date-picker v-if="item.type == 'date'" v-model="query[item.code]" size="mini" type="daterange"
                    style="width: 100%" :format="item.format ? item.format : 'yyyy-MM-dd'"
                    :value-format="item.format ? item.format : 'yyyy-MM-dd'" @input="(val) => dateChange(val, item)"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>

                  <el-date-picker v-if="item.type == 'datetime'" v-model="query[item.code]" size="mini"
                    type="datetimerange" :default-time="['00:00:00', '23:59:59']" format="yyyy-MM-dd HH:mm:ss"
                    style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" @input="(val) => dateChange(val, item)"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>

                  <el-input v-if="item.type == 'input'" v-model="query[item.code]" size="mini"
                    :placeholder="'请填写' + item.name" style="width: 100%" @input="inputEvt"></el-input>

                  <el-input-number v-if="item.type == 'number'" v-model="query[item.code]" :controls="false" size="mini"
                    :placeholder="'请填写' + item.name" style="width: 100%"></el-input-number>

                  <!-- 单选 -->
                  <el-select v-if="item.type == 'select' && !item.multiple" :class="item.code" v-model="query[item.code + 'Name']"
                    size="mini" :placeholder="'请选择' + item.name" style="width: 100%" clearable filterable
                    :multiple="item.multiple ? true : false" :filter-method="(k) =>
                        selectFilterChange(
                          item.filterMethod ? item.filterMethod : null,
                          k,
                          item
                        )
                      " @change="(val) => selectChange(val, item)">
                    <el-option v-for="m in item.data" :key="m.id" :label="item.labelName ? m[item.labelName] : m.name"
                      :value="m.id"></el-option>
                  </el-select>

                  
                  <!-- 多选 -->
                  <el-select v-if="item.type == 'select' && item.multiple" :class="item.code" v-model="query[item.code]" size="mini"
                    :multiple="item.multiple" :placeholder="'请选择' + item.name" style="width: 100%" clearable filterable
                    :filter-method="(k) =>
                        selectFilterChange(
                          item.filterMethod ? item.filterMethod : null,
                          k,
                          item
                        )
                      " @change="(val) => selectMultipleChange(val, item)" >
                    <el-option v-for="m in item.data" :key="item.ward?m.idGroup:m.id" :label="
                    item.ward?
                    m.deptName + ' ' + (m.wardName ? m.wardName : ''):
                     item.labelName ? m[item.labelName] : m.name"
                      :value=" item.ward?m.idGroup:m.id"></el-option>
                  </el-select>

                  
                  <el-checkbox-group v-if="item.type == 'checkbox'" v-model="query[item.code]" size="mini">
                    <el-checkbox v-for="m in item.options" :key="m.id" :label="m.id">{{
                      m.name
                      }}</el-checkbox>
                  </el-checkbox-group>

                    
                  <el-checkbox-group v-if="item.type == 'myCheckbox'" v-model="query[item.code]" @change="myCheckbox" size="mini">
                    <el-checkbox v-for="m in item.options" :key="m.id" :label="m.id">{{ m.name }}</el-checkbox>
                  </el-checkbox-group>

                  <SelectTree v-if="item.type == 'selectTree'" :class="item.code" :checkStrictly="item.checkStrictly" :filterable="true" :filterMethod="(k) =>
                      treeChange(item.filterMethod ? item.filterMethod : null, k, item)" :multiple="!!item.multiple" :size="'mini'" @handleCheckChange="(node) => handleTreeChange(node, item)"
                    :defaultProps="item.defaultProps" :placeholder="'请选择' + item.name" :data="item.data"
                    :defaultValue="item.text" style="width: 300px"></SelectTree>

                  <NumberRange v-if="item.type == 'numberRange'" :startValue.sync="query[item.startCode]"
                    :endValue.sync="query[item.endCode]" />
                    <!-- <NumberRange v-if="item.type == 'numberRange'&&item.minPurchasePrice==" :startValue.sync="query[item.startCode]"
                    :endValue.sync="query[item.endCode]" /> -->
                    <NumberRange1 v-if="item.type == 'numberRange1'" :startValue.sync="query[item.startCode]"
                    :endValue.sync="query[item.endCode]" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div style="float: right; margin-right: 10px; margin-bottom: 10px">
          <el-button class="btn primary" type="primary" v-preventReClick @click="submit">确定</el-button>
          <el-button class="btn default" v-preventReClick @click="reset">恢复默认</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import SelectTree from "@/components/select-tree";
import NumberRange from "@/components/number-range";
import NumberRange1 from "@/components/number-range/indexCopy.vue";
import { Debounce } from "@/utils/utils";
export default {
  name: "TableSelectFilter",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTree,
    NumberRange,
    NumberRange1,
  },
  data () {
    return {
      // query: {},
      isShowSelectDiv: false,
      oldList:[]
    };
  },
  props: {
    options: {
      type: Array,
      default () {
        return [];
      },
    },
    query: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  // watch: {
  //   query: {
  //     handler (newVal, oldVal) {
  //       for (let i = 0; i < this.options.length; i++) {
  //         if (this.options[i].type == "select") {
  //           let val = this.query[this.options[i].code + 'Name']
  //           this.query[this.options[i].code] = val
  //         }
  //       }
  //     },
  //     deep: true
  //   }
  // },
  created () { },
  mounted () {
    // console.log(this.query, "this.query");
    this.query.loginWarehouseId = this.mySessionStorage.getWarehouseId();
    this.$set(this.query, this.query.loginDeptId, this.mySessionStorage.getDeptId());
    this.resetQuery();
  },
  methods: {
    showSelectDiv () {
      this.isShowSelectDiv = !this.isShowSelectDiv;

      if (this.isShowSelectDiv) {
        // var body = document.getElementById('app');
        // this.$refs.fileterDiv.style.setProperty('width', (body.clientWidth - this.$el.offsetLeft) + 'px');
        this.$refs.fileterDiv.style.setProperty(
          "width",
          this.$parent.$el.clientWidth * 0.98 + "px"
        );
        document.addEventListener("click", this.onClobalClick);

        this.$refs.fileterDiv.style.setProperty(
          "left",
          this.$parent.$el.offsetLeft -
          this.$el.offsetLeft +
          this.$parent.$el.clientWidth * 0.01 +
          "px"
        );
      }
    },
    onClobalClick (e) {
      // console.log(e, 'e', e.path)
      let paths = this.getAllParentClass(e);
      // if (e.path) {
      //   paths = e.path.map((item) => item.className);
      // }
      if (
        e.target.className != "select-content" &&
        e.target.className != "select-text" &&
        paths.indexOf("select-content") == -1
      ) {
        this.isShowSelectDiv = false;
        document.removeEventListener("click", this.onClobalClick);
      }
    },
    getAllParentClass (e) {
      let paths = [];
      // self class
      // console.log(e.target.classList)
      if (e.target.classList) {
        e.target.classList.forEach((item) => {
          paths.push(item);
        });
      }

      let parentNode = e.target.parentNode;
      this.getParentClass(parentNode, paths);
      // console.log('paths', paths)

      return paths;
    },
    getParentClass (node, paths) {
      if (node.classList) {
        node.classList.forEach((item) => {
          paths.push(item);
        });
      }
      if (node.parentNode) {
        this.getParentClass(node.parentNode, paths);
      }
    },
    timerangeChange(val,item){
      this.$nextTick(() => {
        let startDateCode = "startDate";
        let endDateCode = "endDate";
        if (item.startDateCode && item.endDateCode) {
          startDateCode = item.startDateCode;
          endDateCode = item.endDateCode;
        }
        
        // if (item.code == "date") {
        if (val&&val.length==2) {
          this.query.startDate= val[0];
          this.query.endDate = val[1];
        
        } else {
          this.query.endDate = "";
          this.query.startDate = "";
        }
      });
      this.$forceUpdate()
    },
    dateChange (val, item) {
      this.$nextTick(() => {
        let startDateCode = "startDate";
        let endDateCode = "endDate";
        if (item.startDateCode && item.endDateCode) {
          startDateCode = item.startDateCode;
          endDateCode = item.endDateCode;
        }

        // if (item.code == "date") {
          if (val == null) {
          this.query[startDateCode] = "";
          this.query[endDateCode] = "";
        } else {
          this.query[startDateCode] = val[0];
          this.query[endDateCode] = val[1];
        }
      });
      this.$forceUpdate()
    },

    reset () {
      // this.resetQuery()
      this.isShowSelectDiv = false;
      this.$emit("reset");
    },
    submit () {
      this.$set(this.query, "pageIndex", 1);
      this.$emit("filterChange", this.query);
      this.isShowSelectDiv = false;
    },
    resetQuery () {
      this.query.keyWord = ''
      // console.log('resetquery', this.options, this.query)
      if (this.options) {
        this.options.forEach((o) => {
          if (o.type == "select") {
            if (o.filterMethod) {
              o.filterMethod("").then((res) => {
                o.data = res;
              });
            }
            let value = "";
            if (o.defaultValue || o.defaultValue == 0) {
              value = o.defaultValue;
            }
            if (this.query[o.code] || this.query[o.code] == 0) {
              value = this.query[o.code];
            }
            this.$set(this.query, o.code, value);
            this.$set(this.query, o.code + "Name", value);
          } else if (o.type == "selectTree") {
            if (o.filterMethod) {
              o.filterMethod().then((res) => {
                o.data = res;
              });
            }
          } else if (o.type == "date") {
            if (!o.startDateCode && !o.endDateCode) {
              o.startDateCode = "startDate";
              o.endDateCode = "endDate";
            }
            if (!this.query[o.startDateCode]) {
              this.$set(this.query, o.startDateCode, "");
            }
            if (!this.query[o.startDateCode]) {
              this.$set(this.query, o.endDateCode, "");
            }
            if (o.defaultValue) {
              this.$set(this.query, o.code, o.defaultValue);
            }
          } else if (o.type == "input") {
            // if (!o.defaultValue) {
            //   this.$set(this.query, o.code, '');
            // }
            let value = "";
            if (o.defaultValue || o.defaultValue == 0) {
              value = o.defaultValue;
            }
            if (this.query[o.code] || this.query[o.code] == 0) {
              value = this.query[o.code];
            }
            this.$set(this.query, o.code, value);
          }

          if (o.type == "checkbox") {
            this.$set(this.query, o.code, []);
          } else if (o.type == "myCheckbox") {
            this.$set(this.query, o.code, []);
          } else if (o.type == "selectTree") {
            this.$set(o, "text", "");
          } else if (o.type == "numberRange") {
            this.$set(this.query, o.startCode, "");
            this.$set(this.query, o.endCode, "");
          } else {
            // let value = ''
            // if (o.defaultValue) {
            //   value = o.defaultValue
            //   console.log(o.defaultValue)
            // }
            // this.$set(this.query, o.code, value);
          }
        });
      }
      if (!this.query.startDate) {
        this.query.startDate = "";
      }

      if (!this.query.endDate) {
        this.query.endDate = "";
      }
    },
    selectFilterChange: Debounce(function (f, keyWord, o) {
      // this.query.loginWarehouseId = this.mySessionStorage.getWarehouseId();
      // this.$set(this.query, this.query.loginDeptId, this.mySessionStorage.getDeptId());
      if (f) {
        f(keyWord).then((res) => {
          o.data = res;
        });
      }
    }, 500),
    selectChange (val, o) {
      // 单选
      // this.query[o.code] = val
      // console.log("query", "--------------------------------");
      // this.query.loginWarehouseId = this.mySessionStorage.getWarehouseId();
      // this.$set(this.query, this.query.loginDeptId, this.mySessionStorage.getDeptId());
      this.$set(this.query, o.code, val);
      let m = o.data.find((e) => e.id == val);
      // this.query[o.code + 'Name'] = m.name
      if (val !== "") {
        this.$set(this.query, o.code + "Name", m.name);
      } else {
        this.$set(this.query, o.code + "Name", "");
      }
    },
    inputEvt(){
      this.$forceUpdate()
    },
    selectMultipleChange (val, o) {
 
      this.query[o.code] = val;
      if(o.ward){
     
          let l = o.data.filter((e) => val.indexOf(e.idGroup) != -1);
          this.query[o.code + "Name"] = l.map((e) => {
            return `${e.deptName} ${e.wardName??''}`
          });
      }else{
          let l = o.data.filter((e) => val.indexOf(e.id) != -1);
          this.query[o.code + "Name"] = l.map((e) => e.name);
      }
      
    },
    
    treeChange (f, keyWord, o) {
      if (f) {
        f(keyWord).then((res) => {
          o.data = res;
        });
      }
    },
    myCheckbox(val){
      
      this.$forceUpdate()
    },
    handleTreeChange (node, o) {
      // this.form.assetType = node.id;
      // this.form.assetTypeName = node.name;
      if (node) {
        if(o.multiple){
          let ids = node.map(res=>res.id)
          let name =  node.map(res=>res.name).join(';')
          this.$set(this.query, o.code, ids);
          this.$set(o, "text", name);
        }else{
          this.$set(this.query, o.code, node.id);
          this.$set(o, "text", node.name);
        }
      
      } else {
        this.$set(this.query, o.code, "");
        this.$set(o, "text", "");
      }
    },
 
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-picker-panel {
  z-index: 3000 !important;
}

.el-form-item {
  margin-bottom: 10px !important;
}

// /deep/.el-form-item__label {
//   margin-top: 4px;
// }

.filter-content {
  margin-top: 3px;
  height: 32px;
  width: 80px;
}

.select-text {
  color: #286ab4;
  font-weight: 400;
  font-size: 14px;
}

.select-content {
  // width: 1707px;
  // height: 258px;
  width: 90%;
  background: #eef6ff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  position: absolute;
  top: 40px;
  // left: -35px;
  z-index: 1002;
  padding-top: 20px;
}

.select-triangle-left {
  border-right: 10px solid #eef6ff;
  border-top: 20px solid transparent;
  position: absolute;
  top: 20px;
  left: 53px;
}

.select-triangle-right {
  border-left: 10px solid #eef6ff;
  border-top: 20px solid transparent;
  position: absolute;
  top: 20px;
  left: 63px;
}

/deep/ .el-form-item__content {
  line-height: 24px;
}

/deep/ .input-number-range {
  border-radius: 0;
}

// /deep/.el-form-item__label {
//   line-height: 30px !important;
// }</style>
